/** Public display only: keep internal IDs and historical references unchanged. */
export function miraNumber(id: string | number): string {
  const value = String(id);
  return /^MIRA-/i.test(value) ? `MIRA-${value.slice(5)}` : `MIRA-${value}`;
}
